import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { FullPageLoader } from '@/components/shared/LoadingSpinner'
import { useAbility } from '@/contexts/AbilityContext'
import type { Actions, Subjects } from '@/libs/ability'
import { APP_ROUTES } from '@/libs/constants'
import { useAppSelector } from '@/store/hooks'

interface ProtectedRouteProps {
  children?: ReactNode
  requiredAction?: Actions
  requiredSubject?: Subjects
}

export function ProtectedRoute({ children, requiredAction, requiredSubject }: ProtectedRouteProps) {
  const location = useLocation()
  const { isAuthenticated, isPermissionsLoaded } = useAppSelector((state) => state.auth)
  const ability = useAbility()

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.auth.login} state={{ from: location }} replace />
  }

  if (requiredAction && requiredSubject && !isPermissionsLoaded) {
    return <FullPageLoader />
  }

  if (requiredAction && requiredSubject && !ability.can(requiredAction, requiredSubject)) {
    return <Navigate to={APP_ROUTES.home} replace />
  }

  return children || <Outlet />
}
